export default function DistList({ title, items, onItemClick }) {
  return (
    <div>
      {title && (
        <div
          className="text-[12px] small-caps font-bold mb-2.5"
          style={{ color: "var(--cv-charcoal-soft)" }}
        >
          {title}
        </div>
      )}
      <div className="flex flex-col gap-2">
        {items.map((it, i) => (
          <button
            key={it.label ?? i}
            type="button"
            data-testid={`dist-item-${i}`}
            onClick={() => onItemClick && onItemClick(it)}
            className={`flex items-center gap-2 text-[13px] text-left ${onItemClick ? "cv-row-clickable rounded px-1.5 py-0.5" : ""}`}
          >
            <span
              className="w-2.5 h-2.5 rounded-full shrink-0"
              style={{ background: it.color || "var(--cv-slate)" }}
            />
            <span className="min-w-[110px]" style={{ color: "var(--cv-charcoal)" }}>{it.label}</span>
            <span className="flex-1 h-[7px] rounded overflow-hidden" style={{ background: "var(--cv-line)" }}>
              <span
                className="block h-full"
                style={{ width: `${it.pct ?? 0}%`, background: it.color || "var(--cv-slate)" }}
              />
            </span>
            <span
              className="min-w-[46px] text-right tabular-nums"
              style={{ color: "var(--cv-charcoal-soft)" }}
            >
              {it.pct != null ? `${it.pct}%` : it.value}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
